import request from '@/utils/http'
import { SRM, SRM_FILE_PRE } from '../../constant/constant.js'

// 分页
export const getExceptionDetailSummary = data => {
    return request({
        url: `${SRM}/supplierExceptionDetailSummary`,
        // url: `/v50/supplierExceptionDetailSummary`,
        method: 'post',
        data,
    })
}

// 设备类-导出
export const exportEquipment = data => {
    return request({
        url: `${SRM_FILE_PRE}/exportSupplierEquipmentComplaintDetailSummary`,
        method: 'post',
        data,
    })
}

// 装卸-导出
export const exportSupplierExceptionDetailSummary = data => {
    return request({
        url: `${SRM_FILE_PRE}/exportSupplierExceptionDetailSummary`,
        method: 'post',
        data,
    })
}
